import React from "react";
import { connect } from 'react-redux';
import { Grid } from "semantic-ui-react";
import { Helmet } from "react-helmet";


const demos = {
    //https://qap.inenco.com/insite/single/?appid=74cf82fc-3a16-49a3-aee0-b269d725e69b&sheet=66860ee6-0f1c-4b51-9407-ab3379ef7f2f&theme=Inenco_Theme&opt=currsel%2Cctxmenu
    qap:
        '<iframe src="https://qap.inenco.com/insite/single/?appid=6ca1a67a-1772-4018-8d1d-b41a54251e44&sheet=235d1fba-80b1-4edf-b599-778b1be7e8d0&select=clearall" style="border:none;max-width:100%!important;width:100%!important;height:1080px!important;"></iframe>'
};
 
function Iframe(props) {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
        />
    );
}

 
const QLIKFRAME = props => (
    <div className='main-container'>
        <Helmet>
            <title>Insite | Budget Report</title>
        </Helmet>
        <Grid padded stackable columns='equal' style={{height: "100%"}}>
            <Grid.Row>
                <Grid.Column>
                    <h2>Budget Report</h2>
                </Grid.Column>
            </Grid.Row>

            <Grid.Row>
                <Grid.Column style={{height: "1120px", display: "block"}}>
                    <div className="App" style={{ height: '100%', position: 'absolute', left: '0px', width: '100%', overflow: 'auto' }}>
                        <Iframe iframe={demos["qap"]} allow="autoplay" style={{ border:'none',width:'100%!important',height:'1080px!important'}} />
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </div>
);
 
export default connect()(QLIKFRAME);